import time from '../../utils/time';

import {
    FETCH_LAST_UPDATE_INFO,
} from '../../actions/lastUpdate';

const initialState = {
    lastUpdate: {},
};

function convertLastUpdateInfo(lastUpdateInfo) {
 return {
    revision: lastUpdateInfo.revision,
    last_update: time.convertDatetimeToLocal(lastUpdateInfo.last_update),
    is_generating: lastUpdateInfo.is_generating,
  };
}

export default function lastUpdateInfoReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_LAST_UPDATE_INFO:
            return {
                ...state,
                lastUpdate: convertLastUpdateInfo(action.payload.data),
            };
        default:
            return state;
    }
}
